module.exports = __webpack_public_path__ + "static/media/iron-man-no-bg.cf7cfa25.png";